export const getNumericFormatter =
  (locale: string, digits = 0): ((value: number) => string) =>
  (value: number) =>
    value?.toLocaleString(locale, {
      minimumFractionDigits: digits ?? 0,
      maximumFractionDigits: digits ?? 0,
    })
